import range from 'lodash/range';
import { Bones } from '@simplywallst/ui-core';

interface Props {
  row?: number;
  column?: number;
}

const SectorsPerformanceSkeleton = ({ row = 1, column = 4 }: Props) => (
  <>
    {range(row).map((i) => (
      <tr key={i} data-cy-id="sectors-performance-skeleton">
        {range(column).map((i) => (
          <td key={i}>
            <span>
              <Bones minHeight={30} />
            </span>
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default SectorsPerformanceSkeleton;
